import { Chain } from './generated';

export const getChainDisplayName = (chain: Chain) => {
  if (chain === Chain.Binance) return 'BNB';

  return chain;
};
